import { BaseMessage } from "./baseMessage";

export abstract class AbstractComparisonDataMessage extends BaseMessage {

}